import React, { useEffect, useState } from 'react'
import { useTemporaryVisible } from '../../../genericComponents/useTemporaryVisible'
import { useT } from '../../../i18n/T'
import StatusMessage from '../../../genericComponents/StatusMessage'

// webpack:BrowserOnly
const UserFavoriteError = ({ marginTop = 10, error }) => {
  const [text, setText] = useState()
  const [visible, setVisible] = useTemporaryVisible()

  useEffect(() => {
    if (error) {
      setText(error?.name ?? 'Error')
      setVisible(true)
    }
  }, [error])

  return <StatusMessage message={useT(text)} visible={visible} />
}

export default UserFavoriteError
